module.exports = __webpack_public_path__ + "img/money-transfer.4172ac24.svg";